import React from 'react'
import { Box, YoutubeVideo } from 'chemistry'

const borderRadius = 8

export default function YouTubeEmbed({ url, height = 400, width = 540, placeholderDisabled = false }) {
  return (
    <Box borderRadius={`${borderRadius}px`} overflow='hidden' width='100%' maxWidth={`${width}px`} m='0 auto'>
      <YoutubeVideo src={url} height={height} showSkeletonOnLoad={!placeholderDisabled} settings={{ autoplay: 0 }} />
    </Box>
  )
}
